/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UserRegistrationWithProvider { 
    email: string;
    password: string;
    privacy_conditions_accepted?: boolean;
    usage_conditions_accepted?: boolean;
    unfair_terms_accepted?: boolean;
    latitude?: number;
    longitude?: number;
    firstName?: string;
    lastName?: string;
    social_security_number?: string;
    address?: string;
    birth_date?: string;
    cap?: string;
    city?: string;
    resid_prov?: string;
    resid_nation_iso?: string;
    driver_license_country?: string;
    driver_license_number?: string;
    driver_license_releasedBy?: string;
    driver_license_expiry_date?: string;
    birth_place?: string;
    gender?: UserRegistrationWithProvider.GenderEnum;
}
export namespace UserRegistrationWithProvider {
    export type GenderEnum = 'Male' | 'Female';
    export const GenderEnum = {
        Male: 'Male' as GenderEnum,
        Female: 'Female' as GenderEnum
    };
}